<template>
  <v-app id="stormport-assets">
    <v-snackbar
      v-model="snackbar.active"
      top
      right
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      <div v-html="snackbar.text" />
    </v-snackbar>

    <v-overlay :opacity="0.8" :z-index="999" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-content>
      <v-container class="fill-height" fluid>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    this.$vuetify.theme.dark = true;
  },
  computed: mapState({
    loading: state => state.loading,
    snackbar: state => state.snackbar
  })
};
</script>
